import { render } from "./Internal_approval_decision.vue?vue&type=template&id=f2cfbb12"
import script from "./Internal_approval_decision.vue?vue&type=script&lang=js"
export * from "./Internal_approval_decision.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__